import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Tilt from 'react-parallax-tilt';
import GameInfo from "./GameInfo";

function GameIcon({
  game,
  iconFrontSrc,
  iconBackSrc,
  onPlayClick,
  onCoomingSoonClick
}) {
  const iconSides = useMemo(() => {
    return (
      <>
        <div className="game-item__icon game-item__icon--front">
          <img src={iconFrontSrc} />
        </div>
        <Tilt className="game-item__icon game-item__icon--back" tiltMaxAngleX={10} tiltMaxAngleY={10}>
          {(!!game.is_coming_soon || !!game.is_icon_only) &&
            <div className="cooming-soon">
              <div className="cooming-soon__bg"></div>
              <span className="cooming-soon__text">Cooming soon!</span>
            </div>
          }
          <img src={iconBackSrc} />
          <div className="icon-buttons">
            <div className="icon-buttons__line"></div>
            <div className="icon-buttons__buttons-container">
              <div className={`icon-buttons__button icon-buttons__button--info ${game.is_icon_only ? 'disabled' : ''}`}>
                <img src="/image/games/info.svg" />
              </div>
              <div className={`icon-buttons__button icon-buttons__button--play ${game.is_coming_soon ? 'disabled' : ''}`}
                onClick={onPlayClick}
              >
                <img src="/image/games/play.svg" />
              </div>
            </div>
            <div className="icon-buttons__line"></div>
          </div>
        </Tilt>
      </>
    )
  }, [game, iconFrontSrc, iconBackSrc]);

  if (!game.is_icon_only) {
    return (
      <a className="game-item__icon-container" href={game.url}>
        {iconSides}
      </a>
    );
  }

  return (
    <div className="game-item__icon-container" onClick={() => onCoomingSoonClick()}>
      {iconSides}
    </div>
  );
}

function GameItem({
  game,
  iconsAlwaysActive
}) {
  const [isActive, setIsActive] = useState(!!iconsAlwaysActive);
  const [isVisible, setIsVisible] = useState(false);
  const [iconFrontSrc, setIconFrontSrc] = useState('');
  const [iconBackSrc, setIconBackSrc] = useState('');
  const iconRef = useRef();

  const onMouseEnter = useCallback(() => {
    if (!iconsAlwaysActive) {
      setIsActive(true);
    }
  }, [iconsAlwaysActive]);

  const onMouseLeave = useCallback(() => {
    if (!iconsAlwaysActive) {
      setIsActive(false);
    }
  }, [iconsAlwaysActive]);

  const onCoomingSoonClick = useCallback(() => {
    if (!iconsAlwaysActive) {
      setIsActive(!isActive);
    }
  }, [isActive, iconsAlwaysActive]);

  useEffect(() => {
    const handleScroll = () => {
      if (iconRef.current) {
        const rect = iconRef.current.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);

        if (isVisible) {
          const imgFront = new Image();
          const imgBack = new Image();

          imgFront.onload = () => {
            setIconFrontSrc(imgFront.src);
          };

          imgBack.onload = () => {
            setIconBackSrc(imgBack.src);
          };

          imgFront.src = game.image_main;
          imgBack.src = game.image_alt;

          window.removeEventListener('scroll', handleScroll);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [game]);

  useEffect(() => {
    if (!!iconFrontSrc && !!iconBackSrc) {
      setTimeout(() => {
        setIsVisible(true);
      }, 100)
    }
  }, [iconFrontSrc, iconBackSrc]);

  const onPlayClick = useCallback((e) => {
    e.preventDefault();
    if (!game.is_coming_soon && !game.is_icon_only) {
      window.startGame(game.id, game.code, undefined, undefined, undefined);
    }
  }, [game]);

  return (
    <div className={`game-item ${isActive ? 'is-active' : ''} ${isVisible ? 'is-visible' : ''} ${game.is_coming_soon ? 'is-coming-soon' : ''} ${game.is_icon_only ? 'is-icon-only' : ''}`}
      onMouseEnter={() => onMouseEnter()}
      onMouseLeave={() => onMouseLeave()}
      ref={iconRef}
    >
      <GameIcon
        game={game}
        iconFrontSrc={iconFrontSrc}
        iconBackSrc={iconBackSrc}
        onPlayClick={onPlayClick}
        onCoomingSoonClick={onCoomingSoonClick}
      />
      <GameInfo game={game} isVisible={isActive} />
    </div>
  );
}

export default GameItem;
